import { useParams } from 'react-router-dom';

import { PrepareAndroidPackagePage } from '~/components/pages/PrepareAndroidPackagePage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const PrepareAndroidPackageRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <PrepareAndroidPackagePage appId={appId} />
    </DashboardTemplate>
  );
};
